import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { IContact } from 'src/services/api/contacts/types';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { CONTACTS_PATH } from 'src/services/api/contacts/constants';

export type ISetContactPropertiesRequest = {
    id: number;
    /**
     * Replaces the contact's full set of linked properties.
     */
    property_ids: number[];
};

type ISetContactPropertiesResponse = {
    contact: IContact;
};

export const useSetContactProperties = () => {
    const queryClient = useQueryClient();

    return useMutation<IContact, IStandardErrorResponse, ISetContactPropertiesRequest>(
        async ({ id, property_ids }) => {
            const res = await apiClient(`${CONTACTS_PATH}/${id}/properties`, {
                method: 'put',
                json: { property_ids },
            }).json<ISetContactPropertiesResponse>();

            return res.contact;
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKeys.contacts);
            }
        }
    );
};
